var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "quill" }, [
    _c("div", { attrs: { id: _vm.toolbarId } }, [_vm._m(0)]),
    _c("div", { ref: "editor", attrs: { id: _vm.editorId, name: _vm.name } }),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "ql-formats" }, [
      _c("button", { staticClass: "ql-bold" }),
      _c("button", { staticClass: "ql-italic" }),
      _c("button", { staticClass: "ql-underline" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }